(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/make-store.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/make-store.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _RTK = RTK,
  combineReducers = _RTK.combineReducers,
  createNextState = _RTK.createNextState,
  configureStore = _RTK.configureStore;
const _RTKQ = RTKQ,
  setupListeners = _RTKQ.setupListeners;
const getLogger = svs.core.log.getLogger;
const _svs$components$tipse = svs.components.tipsen.engine,
  getReducers = _svs$components$tipse.getReducers,
  definitions = _svs$components$tipse.definitions,
  createCoupons = _svs$components$tipse.createCoupons,
  engineActions = _svs$components$tipse.actions,
  engineConstants = _svs$components$tipse.constants;
const _svs$components$tipse2 = svs.components.tipsen.store.reducers,
  moduleReducer = _svs$components$tipse2.moduleReducer,
  couponSettingsReducer = _svs$components$tipse2.couponSettingsReducer;
const drawsReducer = svs.components.sport.drawsRedux.slice.reducer;
const fundsReducer = svs.components.sport.fundsRedux.slice.reducer;
const playerWagerSlice = svs.components.tipsen.store.reducers.playerWager.slice;
const resultModifierReducer = svs.components.tipsen.store.reducers.resultModifier.reducer;
const betslipSlice = svs.components.tipsen.store.reducers.betslipSlice.slice;
const makePlayerWagerListReducer = svs.components.tipsen.store.reducers.playerWagerListSubscriptionSlice.makePlayerWagerListReducer;
const walletReducer = svs.components.tipsen.wallet.walletReducer;
const _svs$components$tipse3 = svs.components.tipsen.loadingState,
  loadingStateReducer = _svs$components$tipse3.loadingStateReducer,
  loadingStateMiddleware = _svs$components$tipse3.loadingStateMiddleware;
const _svs$components$sport = svs.components.sportinfo.matchInfoRedux,
  betEventReducer = _svs$components$sport.betEventReducer,
  sportEventReducer = _svs$components$sport.sportEventReducer,
  leagueReducer = _svs$components$sport.leagueReducer,
  sportReducer = _svs$components$sport.sportReducer,
  participantReducer = _svs$components$sport.participantReducer,
  countryReducer = _svs$components$sport.countryReducer,
  eventTypeStatisticReducer = _svs$components$sport.eventTypeStatisticReducer,
  generateParticipantsMw = _svs$components$sport.generateParticipantsMw,
  matchInfoActions = _svs$components$sport.actions;
const gameAnalysesReducer = svs.components.sportinfo.gameAnalysesRedux.gameAnalysesReducer;
const articleReducer = svs.components.tipsen.article.articleReducer;
const newsTTReducer = svs.components.sportinfo.newsTT.newsTTReducer;
const _svs$components$tipse4 = svs.components.tipsen.store.middlewares,
  actionEnhancerMw = _svs$components$tipse4.actionEnhancerMw,
  kibanaMw = _svs$components$tipse4.kibanaMw,
  dialogMw = _svs$components$tipse4.dialogMw,
  trackingMw = _svs$components$tipse4.trackingMw,
  makeLocalStorageMiddleware = _svs$components$tipse4.makeLocalStorageMiddleware;
const _svs$components$tipse5 = svs.components.tipsen.store,
  createReducerManager = _svs$components$tipse5.createReducerManager,
  createMiddlewareManager = _svs$components$tipse5.createMiddlewareManager,
  tipsenApi = _svs$components$tipse5.tipsenApi,
  makeDrawsApi = _svs$components$tipse5.makeDrawsApi;
const competitionReducer = svs.components.marketplaceCompetition.services.reducers.reducer;
const competitionMiddlewares = svs.components.marketplaceCompetition.services.middlewares.competitionMiddlewares;
const competitionHandler = svs.components.marketplaceCompetition.competitionHandler.competitionHandler;
const videoAnalysesReducer = svs.components.tipsen.store.reducers.videoAnalysesSlice.reducer;
const blacklistedCouponValues = {
  selectedSystem: 0
};
const qs = new URLSearchParams(location.search);
const isExtendedReduxDevTools = typeof qs.get('extendedReduxDevTools') === 'string';
qs.delete('extendedReduxDevTools');
if (isExtendedReduxDevTools) {
  window.history.replaceState({}, null, "?".concat(qs.toString()));
}
const defaultAnalyseState = {
  showAll: false,
  showAnalyseForecast: false,
  hideAll: true
};
const makeStore = _ref => {
  var _cachedData$Coupons, _cachedData$CouponSet, _cachedData$PlayerWag, _clientStoredCouponSe, _clientStoredCouponSe2, _clientStoredCouponSe3, _clientStoredCouponSe4, _clientStoredCouponSe5, _clientStoredPlayerWa;
  let preloadedState = _ref.preloadedState,
    lsKey = _ref.lsKey;
  const localStorageMw = makeLocalStorageMiddleware(lsKey, (persistedData, getState) => {
    var _PlayerWager$WagerLis;
    const lsLogger = getLogger('tipsen:store:mw:ls');
    const _ref2 = persistedData || {},
      Coupons = _ref2.Coupons,
      CouponSettings = _ref2.CouponSettings,
      PlayerWager = _ref2.PlayerWager;
    const state = getState();
    const _ref3 = state || {},
      newCoupons = _ref3.Coupons,
      newCouponSettings = _ref3.CouponSettings,
      newCorrectsToggle = _ref3.PlayerWager.WagerListSettings.WagerListSubscriptionSettings.correctsToggle;
    const baseState = {
      Coupons: Coupons || {},
      CouponSettings: CouponSettings || {},
      PlayerWager: {
        WagerListSettings: {
          WagerListSubscriptionSettings: {
            correctsToggle: (PlayerWager === null || PlayerWager === void 0 || (_PlayerWager$WagerLis = PlayerWager.WagerListSettings) === null || _PlayerWager$WagerLis === void 0 || (_PlayerWager$WagerLis = _PlayerWager$WagerLis.WagerListForecastSubscriptions) === null || _PlayerWager$WagerLis === void 0 ? void 0 : _PlayerWager$WagerLis.correctsToggle) || {}
          }
        }
      }
    };
    const persistData = createNextState(baseState, draftState => {
      var _draftState$PlayerWag;
      newCorrectsToggle && Object.assign((_draftState$PlayerWag = draftState.PlayerWager) === null || _draftState$PlayerWag === void 0 || (_draftState$PlayerWag = _draftState$PlayerWag.WagerListSettings) === null || _draftState$PlayerWag === void 0 || (_draftState$PlayerWag = _draftState$PlayerWag.WagerListSubscriptionSettings) === null || _draftState$PlayerWag === void 0 ? void 0 : _draftState$PlayerWag.correctsToggle, newCorrectsToggle);
      newCoupons && Object.assign(draftState.Coupons, newCoupons);
      newCouponSettings && Object.assign(draftState.CouponSettings, newCouponSettings);

      for (const _ref4 of Object.entries(draftState.Coupons)) {
        var _ref5 = _slicedToArray(_ref4, 2);
        const key = _ref5[0];
        const value = _ref5[1];
        if (value.isExternal) {
          draftState.Coupons[key].boards = [];
        }
        if (!state.Coupons[key].isModified) {
          delete draftState.Coupons[key];
        }
      }
    });
    lsLogger.debug(persistData);
    return persistData;
  });
  const cachedData = localStorageMw.getCachedData();
  const clientStoredCoupons = (_cachedData$Coupons = cachedData === null || cachedData === void 0 ? void 0 : cachedData.Coupons) !== null && _cachedData$Coupons !== void 0 ? _cachedData$Coupons : {};
  const clientStoredCouponSettings = (_cachedData$CouponSet = cachedData === null || cachedData === void 0 ? void 0 : cachedData.CouponSettings) !== null && _cachedData$CouponSet !== void 0 ? _cachedData$CouponSet : {};
  const clientStoredPlayerWagerSettings = (_cachedData$PlayerWag = cachedData === null || cachedData === void 0 ? void 0 : cachedData.PlayerWager) !== null && _cachedData$PlayerWag !== void 0 ? _cachedData$PlayerWag : {};
  const preloadedCoupons = {};
  const engineDefinition = definitions[preloadedState.Module.engine];
  const comphandler = competitionHandler();
  const competitions = comphandler.getActiveCompetition(definitions[preloadedState.Module.engine].drawProductIds[0]);
  const playerCompetitionDetails = comphandler.getPlayerCompetitions();
  if (preloadedState.Draws) {
    for (const couponId of Object.keys(clientStoredCoupons)) {
      const drawId = couponId.slice(0, couponId.lastIndexOf('_'));
      const productId = Number(drawId.slice(0, drawId.indexOf('_')));

      if (!engineDefinition.drawProductIds.includes(productId)) {
        continue;
      }

      if (!preloadedState.Draws.entities[drawId]) {
        delete clientStoredCoupons[couponId];
        continue;
      }

      for (const _ref6 of Object.entries(blacklistedCouponValues)) {
        var _ref7 = _slicedToArray(_ref6, 2);
        const blacklistedCouponKey = _ref7[0];
        const defaultValue = _ref7[1];
        clientStoredCoupons[couponId][blacklistedCouponKey] = defaultValue;
      }
    }
    Object.assign(preloadedCoupons, createCoupons({
      draws: preloadedState.Draws.entities,
      engineDefinition
    }));
  }
  Object.assign(preloadedCoupons, clientStoredCoupons);
  const defaultOutcomeInfoChoises = {
    display: engineConstants.TipsinfoTypes.OutcomeLabel,
    displayResult: engineConstants.TipsinfoTypes.OutcomeLabel,
    displayMyBets: engineConstants.TipsinfoTypes.OutcomeLabel
  };
  const clientStoredOutcomeInfoChoises = (_clientStoredCouponSe = clientStoredCouponSettings === null || clientStoredCouponSettings === void 0 ? void 0 : clientStoredCouponSettings.OutcomeInfoChoises) !== null && _clientStoredCouponSe !== void 0 ? _clientStoredCouponSe : {};
  const preloadedOutcomeInfoChoises = _objectSpread(_objectSpread({}, defaultOutcomeInfoChoises), clientStoredOutcomeInfoChoises);
  const defaultVideoAnalyses = {
    show: true,
    showResult: false,
    showMyBets: false
  };
  const clientStoredVideoAnalyses = (_clientStoredCouponSe2 = clientStoredCouponSettings === null || clientStoredCouponSettings === void 0 ? void 0 : clientStoredCouponSettings.VideoAnalyses) !== null && _clientStoredCouponSe2 !== void 0 ? _clientStoredCouponSe2 : {};
  const preloadedVideoAnalyses = _objectSpread(_objectSpread({}, defaultVideoAnalyses), clientStoredVideoAnalyses);
  const clientStoredMatchAnalyses = (_clientStoredCouponSe3 = clientStoredCouponSettings === null || clientStoredCouponSettings === void 0 ? void 0 : clientStoredCouponSettings.MatchAnalyses) !== null && _clientStoredCouponSe3 !== void 0 ? _clientStoredCouponSe3 : {};
  const defaultMatchAnalyses = {
    bet: defaultAnalyseState,
    result: defaultAnalyseState,
    myBets: defaultAnalyseState
  };
  const preloadedMatchAnalyses = _objectSpread(_objectSpread({}, defaultMatchAnalyses), clientStoredMatchAnalyses);

  const defaultTipsinfo = {
    [engineDefinition.moduleEngine]: {
      odds: {
        state: true,
        stateResult: false,
        stateMyBets: false
      },
      svenskaFolket: {
        state: true,
        stateResult: false,
        stateMyBets: false
      },
      tioTidningar: {
        state: false,
        stateResult: false,
        stateMyBets: false
      },
      matchStart: {
        state: false,
        stateResult: false,
        stateMyBets: false
      },
      startOdds: {
        state: false,
        stateResult: false,
        stateMyBets: false
      },
      favourites: {
        state: false,
        stateResult: false,
        stateMyBets: false
      },
      mutuals: {
        state: false,
        stateResult: false,
        stateMyBets: false
      },
      overUnder: {
        state: false,
        stateResult: false,
        stateMyBets: false
      },
      [engineConstants.TipsinfoTypes.OutcomeLabel]: preloadedOutcomeInfoChoises,
      [engineConstants.TipsinfoTypes.VideoAnalyses]: preloadedVideoAnalyses,
      [engineConstants.TipsinfoTypes.Analys]: preloadedMatchAnalyses
    }
  };
  const clientStoredTipsinfo = (_clientStoredCouponSe4 = clientStoredCouponSettings === null || clientStoredCouponSettings === void 0 ? void 0 : clientStoredCouponSettings.Tipsinfo) !== null && _clientStoredCouponSe4 !== void 0 ? _clientStoredCouponSe4 : {};
  const preloadedTipsinfo = _objectSpread(_objectSpread({}, defaultTipsinfo), clientStoredTipsinfo);
  const defaultCompressedCoupon = {
    [engineDefinition.moduleEngine]: {
      show: engineDefinition.couponSettings.includes(engineConstants.coupon.Compressed),
      showResult: false,
      showMyBets: false
    }
  };
  const clientStoredCompressedCoupon = (_clientStoredCouponSe5 = clientStoredCouponSettings === null || clientStoredCouponSettings === void 0 ? void 0 : clientStoredCouponSettings.CompressedCoupon) !== null && _clientStoredCouponSe5 !== void 0 ? _clientStoredCouponSe5 : {};
  const preloadedCompressedCoupon = _objectSpread(_objectSpread({}, defaultCompressedCoupon), clientStoredCompressedCoupon);
  const defaultPlayerWagerSettingsCorrectsToggle = {
    [engineDefinition.moduleEngine]: {
      active: true,
      finished: false
    }
  };
  const clientPlayerWagerSettingsCorretsToggle = clientStoredPlayerWagerSettings === null || clientStoredPlayerWagerSettings === void 0 || (_clientStoredPlayerWa = clientStoredPlayerWagerSettings.WagerListSettings) === null || _clientStoredPlayerWa === void 0 || (_clientStoredPlayerWa = _clientStoredPlayerWa.WagerListSubscriptionSettings) === null || _clientStoredPlayerWa === void 0 ? void 0 : _clientStoredPlayerWa.correctsToggle;
  const playerWagerSettingsCorrectsToggle = _objectSpread(_objectSpread({}, defaultPlayerWagerSettingsCorrectsToggle), clientPlayerWagerSettingsCorretsToggle);
  const preloadedPlayerWagerSettings = {
    correctsToggle: playerWagerSettingsCorrectsToggle
  };
  const baseReducers = {
    [tipsenApi.reducerPath]: tipsenApi.reducer,
    Articles: articleReducer,
    BetEvents: betEventReducer,
    Betslip: betslipSlice,
    Competition: competitionReducer(competitions, playerCompetitionDetails),
    Countries: countryReducer,
    CouponSettings: couponSettingsReducer,
    Draws: drawsReducer,
    EventTypeStatistic: eventTypeStatisticReducer,
    Funds: fundsReducer,
    gameAnalyses: gameAnalysesReducer,
    Leagues: leagueReducer,
    loadingState: loadingStateReducer,
    Module: moduleReducer,
    newsTT: newsTTReducer,
    Participants: participantReducer,
    PlayerWager: combineReducers({
      DrawForecastSubscriptions: playerWagerSlice,
      WagerListSettings: makePlayerWagerListReducer(preloadedPlayerWagerSettings)
    }),
    ResultModifier: resultModifierReducer,
    SportEvents: sportEventReducer,
    Sports: sportReducer,
    VideoAnalyses: videoAnalysesReducer,
    Wallet: walletReducer
  };
  const reducerManager = createReducerManager(_objectSpread(_objectSpread({}, getReducers(preloadedCoupons)), baseReducers));
  const mwManager = createMiddlewareManager();
  const storePreloadState = _objectSpread({
    CouponSettings: {
      Tipsinfo: preloadedTipsinfo,
      CompressedCoupon: preloadedCompressedCoupon
    }
  }, preloadedState);
  const drawsApi = {};
  const store = configureStore({
    reducer: reducerManager.reducer,
    preloadedState: storePreloadState,
    middleware: getDefaultMiddleware => [...getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: {
        extraArgument: {
          tipsenApi,
          drawsApi
        }
      }
    }), tipsenApi.middleware, loadingStateMiddleware, generateParticipantsMw([{
      action: matchInfoActions.updateMatchOdds,
      getMatchIdFn: action => action.payload.matchId
    }, {
      action: matchInfoActions.fetchMatchInfo.fulfilled,
      getMatchIdFn: action => action.meta.arg
    }]), actionEnhancerMw,
    kibanaMw, localStorageMw, trackingMw, dialogMw, ...competitionMiddlewares,
    mwManager.enhancer],
    devTools: isExtendedReduxDevTools ? {
      maxAge: 250,
      trace: true,
      actionsDenylist: ['TipsenAPI/executeQuery/rejected'],
      shouldCatchErrors: true
    } : true
  });
  Object.assign(drawsApi, makeDrawsApi(store));
  store.reducerManager = reducerManager;
  store.mwManager = mwManager;
  setupListeners(store.dispatch);
  return store;
};
setGlobal('svs.components.tipsen.store.makeStore', makeStore);

 })(window);